import {
  PROPERTY_GRID_SUBJECT_PROPERTY,
  schAlertType,
  schPairedCostRouteItem,
} from '@aloft/toolkit-shared';

import { AlertDefinition } from '../../types.ts';

export const propertyWithoutPhoto: AlertDefinition = ({ compSequence, propertyImageEntities }) => {
  const propertyIds = [PROPERTY_GRID_SUBJECT_PROPERTY, ...compSequence];

  const propertyWithoutPhotoIndex = propertyIds.findIndex((id) => !propertyImageEntities?.[id]);
  if (propertyWithoutPhotoIndex === -1) return undefined;

  const faultyProperty =
    propertyWithoutPhotoIndex === 0 ? 'Subject' : `Comp ${propertyWithoutPhotoIndex}`;
  const faultyPropertyId = propertyIds[propertyWithoutPhotoIndex];

  return {
    type: schAlertType.enum.propertyWithoutPhoto,
    status: 'active',
    severity: 'error',
    message: `Property ${faultyProperty} does not have a photo.`,
    propertyID: faultyPropertyId,
    fixingInfo: {
      tips: "Tips: Adding photos for each property in the analysis can enhance the credibility of your appraisal report and provide valuable context for reviewers. Ensure that the photos are clear, well-lit, and accurately represent the property's condition and features.",
      pairedCostRouteItem: schPairedCostRouteItem.enum.features,
      fixingMethod: ['action'],
      commentAlwaysRequired: false,
    },
    triggers: [
      'navigate/market',
      'navigate/cost-approach',
      'navigate/adjustments',
      'navigate/commentary',
      'navigate/reconciliation',
    ],
  };
};
